import { render, staticRenderFns } from "./addOrModifyTestQs.vue?vue&type=template&id=71701588"
import script from "./addOrModifyTestQs.vue?vue&type=script&lang=ts"
export * from "./addOrModifyTestQs.vue?vue&type=script&lang=ts"
import style0 from "./addOrModifyTestQs.vue?vue&type=style&index=0&id=71701588&prod&lang=scss"
import style1 from "./addOrModifyTestQs.vue?vue&type=style&index=1&id=71701588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports